import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { Implementation } from "../types/implementation";

export const getImplementation: (config: {
  "app-id": string;
  "implementation-id": string;
}) => Promise<Implementation> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Impl "omega/query-omega/public/api/implementation")
        (Qo.Public.Api.Impl/get-implementation ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const getAllImplementations: (config: {
  "app-id": string;
}) => Promise<Implementation[]> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Impl "omega/query-omega/public/api/implementation")
        (Qo.Public.Api.Impl/get-all-available-implementations ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const getPageImplementations: (config: {
  "app-id": string;
  "page-id": string;
}) => Promise<Implementation[]> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Impl "omega/query-omega/public/api/implementation")
        (Qo.Public.Api.Impl/get-page-implementations ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
